/**
 * unhighlight textzone by removing the styles
 * @param textZone fabtric.texbox
 */
export const unhighlightText = (textZone) => {
  if (textZone.styles) {
    delete textZone.styles;
  }
};
